import { p as parser, f as flowDb } from "./flowDb-01624e90.js";
import { f as flowRendererV2, a as flowStyles } from "./styles-4fcf332f.js";
import { q as setConfig } from "./mermaid-306576ad.js";
import "d3";
import "dagre-d3-es/src/graphlib/index.js";
import "./index-892ad7fb.js";
import "dagre-d3-es/src/dagre/index.js";
import "dagre-d3-es/src/graphlib/json.js";
import "./edges-c959041a.js";
import "./createText-b670c180.js";
import "mdast-util-from-markdown";
import "ts-dedent";
import "./svgDraw-b48a99d5.js";
import "dagre-d3-es/src/dagre-js/label/add-html-label.js";
import "khroma";
import "dayjs";
import "@braintree/sanitize-url";
import "dompurify";
import "lodash-es/memoize.js";
import "stylis";
import "lodash-es/isEmpty.js";
const diagram = {
  parser,
  db: flowDb,
  renderer: flowRendererV2,
  styles: flowStyles,
  init: (cnf) => {
    if (!cnf.flowchart) {
      cnf.flowchart = {};
    }
    cnf.flowchart.arrowMarkerAbsolute = cnf.arrowMarkerAbsolute;
    setConfig({ flowchart: { arrowMarkerAbsolute: cnf.arrowMarkerAbsolute } });
    flowRendererV2.setConf(cnf.flowchart);
    flowDb.clear();
    flowDb.setGen("gen-2");
  }
};
export {
  diagram
};
